import * as types from './types';

const initialState = {
  refreshing: false,
  loaded: false,
  loggedOut: null,
  loading: false,
  authenticated: false,
  accountErrors: [],
  currentAccount: null,
  fetchCompleted: false,
  employerProfiles: [],
  meta: {},
};

const accountReducer = (state = initialState, { type, payload, errors }) => {
  const arrErrors = errors ? [].concat(errors) : [];

  switch (type) {
    case types.ACCOUNT_META_LOAD_SUCCESS:
      return {
        ...state,
        meta: payload,
      };
    case types.RESET_PASSWORD_FAIL:
      return {
        ...state,
        accountErrors: arrErrors,
      };
    case types.ACCOUNT_LOAD_SUCCESS:
      return {
        ...state,
        authenticated: true,
        currentAccount: payload,
        loaded: true,
        loading: false,
        loggedOut: false,
        fetchCompleted: true,
      };
    case types.ACCOUNT_LOAD_START:
      return {
        ...state,
        loaded: false,
        loading: true,
        fetchCompleted: false,
      };
    case types.ACCOUNT_LOAD_FAILURE:
      return {
        ...state,
        loaded: true,
        authenticated: false,
        loading: false,
        fetchCompleted: true,
        accountErrors: arrErrors,
      };
    case types.ACCOUNT_NOT_FOUND:
      return {
        ...state,
        authenticated: false,
        loaded: true,
        loading: false,
        accountErrors: arrErrors,
      };
    case types.LOGOUT_START:
      return {
        ...state,
        loading: true,
        authenticated: false,
        loggedOut: true,
      };
    case types.REGISTER_START:
      return {
        ...state,
        loading: true,
        fetchCompleted: false,
      };
    case types.REGISTER_SUCCESS:
      return {
        ...state,
        accountErrors: [],
        loggedOut: false,
        authenticated: true,
        fetchCompleted: true,
      };
    case types.REFRESH_START:
      return {
        ...state,
        refreshing: true,
      };
    case types.REFRESH_SUCCESS:
      return {
        ...state,
        refreshing: false,
        loading: false,
      };
    case types.REGISTER_FAILURE:
      return {
        ...state,
        loading: false,
        loggedOut: true,
        accountErrors: arrErrors,
      };
    case types.LOGOUT:
      return {
        ...state,
        authenticated: false,
        loaded: true,
        loading: false,
        loggedOut: true,
      };
    case types.CURRENT_ACCOUNT_EMPLOYER_PROFILES_LOAD_SUCCESS:
      return {
        ...state,
        employerProfiles: payload,
      };
    default:
      return state;
  }
};

export default accountReducer;
